export default "__VITE_ASSET__3511fa49__"